export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8742.315dfc99.jpg";